import React from "react"
import Contact from "../shared/top/Contact"

const TopContact = () => {
  return <Contact target="do" tel="0278-25-4772" />
}

export default TopContact
